var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30.6337,
    height: 28.6573,
    rx: 2.18812,
    fill: "#006AB3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07114 21.8889H21.9289C22.2003 21.889 22.4616 21.9905 22.6601 22.1732C22.8584 22.3557 22.9789 22.6057 22.9975 22.8725C23.016 23.1394 22.9311 23.4031 22.7597 23.6106C22.5884 23.818 22.3435 23.9537 22.0746 23.9901L21.9289 24H9.07114C8.79967 23.9999 8.53835 23.8984 8.33998 23.7157C8.14162 23.5332 8.021 23.2832 8.0025 23.0164C7.98398 22.7495 8.06898 22.4858 8.24029 22.2783C8.41161 22.0709 8.65648 21.9352 8.92542 21.8987L9.07114 21.8889ZM15.3543 5.00985L15.5 5C15.7589 5.00001 16.0091 5.09238 16.2042 5.26005C16.3994 5.4277 16.5262 5.6593 16.5615 5.912L16.5715 6.05556V16.8757L19.7931 13.7034C19.9747 13.5245 20.2157 13.4158 20.4718 13.3972C20.728 13.3786 20.9824 13.4513 21.1889 13.6021L21.3089 13.7034C21.4905 13.8824 21.6007 14.1197 21.6196 14.3721C21.6385 14.6245 21.5647 14.8752 21.4117 15.0784L21.3089 15.1967L16.2572 20.1719C16.0758 20.3506 15.8352 20.4592 15.5793 20.4781C15.3235 20.497 15.0692 20.4248 14.8629 20.2746L14.7429 20.1719L9.69117 15.1967C9.49946 15.0084 9.38723 14.7555 9.37706 14.4889C9.36689 14.2224 9.45952 13.9619 9.63633 13.7599C9.81315 13.5579 10.061 13.4294 10.3301 13.4001C10.5993 13.3708 10.8697 13.443 11.0869 13.6021L11.207 13.7034L14.4286 16.8785V6.05556C14.4286 5.80048 14.5223 5.55404 14.6924 5.3618C14.8627 5.16956 15.0977 5.04454 15.3543 5.00985Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.8e54fde678622f9c69dec7d9c36408a1.svg";
export { ForwardRef as ReactComponent };